<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import type { SmartmodelMessage } from './types/smartmodel-message';

  const dispatch = createEventDispatcher<{ navigate: SmartmodelMessage }>();

  const handleNavigationClick = (path: string) => {
    dispatch('navigate', { receiver: 'router', data: path });
  };
</script>

<div class="container-fluid">
  <div class="row">
    <div class="col-auto">
      <button class="btn btn-primary" on:click="{() => handleNavigationClick('/')}"> Do PZT </button>
    </div>
    <div class="col-auto">
      <button class="btn btn-primary" on:click="{() => handleNavigationClick('/building/Korona%20Legionowa')}"> Budynek </button>
    </div>
    <div class="col-auto">
      <button class="btn btn-primary" on:click="{() => handleNavigationClick('/building/Korona%20Legionowa?select=KL-LM-70')}"> Budynek z selectem </button>
    </div>
  </div>
</div>
